<template>
	<div class="content-button">
		<div :class="`button-text ${control && itemNumberApprove > 0 ? 'button-active': 'button-unactive'} `" @click="onApprove()">
			<v-icon v-if="$vuetify.breakpoint.lgAndUp && !approveLoading" small color="white" class="mr-1">mdi-check</v-icon>
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && approveLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#FFFFFF`" indeterminate></v-progress-circular>
			Approve
			<span v-if="itemNumberApprove > 0">({{ itemNumberApprove }})</span>
		</div>
		<div :class="`button-text button-default-text ml-2 ${control && itemNumberMoreInfo > 0 ? 'button-default-able':'button-default-unable'}`" @click="onMoreInfo()">
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && rejectLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			<span>Reject</span>
			<span v-if="$vuetify.breakpoint.mdAndUp && itemNumberMoreInfo > 0">({{ itemNumberMoreInfo }})</span>
		</div>
		<div :class="`button-text ${control && itemNumberForward > 0 ? 'button-default-able':'button-default-unable'} ml-2`" @click="onForward()">
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && forwardLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			<span v-if="$vuetify.breakpoint.lgAndUp">Forward</span>
			<span v-else>Forward</span>
			<span v-if="itemNumberForward > 0">({{ itemNumberForward }})</span>
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp" :class="`button-text ${control && itemNumberDelete > 0 ? 'button-default-able':'button-default-unable'} ml-2`" @click="onDelete()">
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && deleteLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			Delete
			<span v-if="$vuetify.breakpoint.lgAndUp && itemNumberDelete > 0">({{ itemNumberDelete }})</span>
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp" :class="`button-text ${control ? 'button-default-able':'button-default-unable'} ml-2`" @click="onPrint()">
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && printLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			Print
			<span v-if="$vuetify.breakpoint.lgAndUp && itemNumberPrint > 0">({{ itemNumberPrint }})</span>
		</div>
	</div>
</template>
<script>
export default {
	name: 'ApprovalButton',
	props: {
		control: {
			type: Boolean,
			default: false
		},
		itemNumberApprove: {
			type: Number,
			default: 0
		},
		itemNumberMoreInfo: {
			type: Number,
			default: 0
		},
		itemNumberForward: {
			type: Number,
			default: 0
		},
		itemNumberPrint: {
			type: Number,
			default: 0
		},
		itemNumberDelete: {
			type: Number,
			default: 0
		},
		approveLoading: {
			type: Boolean,
			default: false
		},
		rejectLoading: {
			type: Boolean,
			default: false
		},
		forwardLoading: {
			type: Boolean,
			default: false
		},
		deleteLoading: {
			type: Boolean,
			default: false
		},
		printLoading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onApprove() {
			if (this.control && this.itemNumberApprove > 0) {
				this.$emit('approve');
			}
		},
		onMoreInfo() {
			if (this.control && this.itemNumberMoreInfo > 0) {
				this.$emit('more-info');
			}
		},
		onForward() {
			if (this.control && this.itemNumberForward > 0) {
				this.$emit('forward');
			}
		},
		onDelete() {
			if (this.control && this.itemNumberDelete > 0) {
				this.$emit('delte')
			}
		},
		onPrint() {
			if (this.control) {
				this.$emit('print')
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.content-button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.button-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  padding: 0 12px;
  border-radius: 4px;
}
.button-active {
  background: #00AAFD;
  color: #FFFFFF;
  &:hover {
    cursor: pointer;
  }
}
.button-unactive {
  background: rgba(25, 42, 62, 0.15);
  color: #FFFFFF;
}
.button-default-able {
  border: 1px solid #00AAFD;
  color: #00AAFD;
  &:hover {
    cursor: pointer;
  }
}
.button-default-unable {
  border: 1px solid rgba(25, 42, 62, 0.3);
  color: rgba(25, 42, 62, 0.3);
}

</style>